/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Sujith Dachepally
 * Created: 15/05/24
 */

import { BulkActionResponse } from '@/wpt-lib/interfaces/Workplan';
import { Flex, Text } from '@chakra-ui/react';
import { CheckCircleIcon, Icon, InfoIcon, WarningIcon } from '@chakra-ui/icons';
import * as React from 'react';

type BulkActionMessageProps = {
    updatedResponse: BulkActionResponse;
};
const BulkActionMessage: React.FC<BulkActionMessageProps> = ({ updatedResponse }) => {
    return (
        <Flex direction="column" alignItems="flex-start" gap={2} my={4} id="table-error-message" aria-live="assertive">
            {updatedResponse.updatedWorkplans.length > 0 && (
                <Flex alignItems="center">
                    <Icon as={CheckCircleIcon} color="green.500" boxSize={4} mr={1} />
                    <Text fontWeight="bold" color="gray.700">
                        {`${updatedResponse.updatedWorkplans.length} Workplan${
                            updatedResponse.updatedWorkplans.length !== 1 ? 's' : ''
                        } approved`}
                    </Text>
                </Flex>
            )}
            {updatedResponse.rejectedWorkplans.length > 0 && (
                <Flex alignItems="center">
                    <Icon as={WarningIcon} color="red.500" boxSize={4} mr={1} />
                    <Text fontWeight="bold" color="gray.700">
                        {`${updatedResponse.rejectedWorkplans.length} Workplan${
                            updatedResponse.rejectedWorkplans.length !== 1 ? 's' : ''
                        } could not be approved. These workplans are highlighted in red.`}
                    </Text>
                </Flex>
            )}
            {updatedResponse.updatedWorkplans.length === 0 && updatedResponse.rejectedWorkplans.length === 0 && (
                <Flex alignItems="center">
                    <Icon as={InfoIcon} color="blue.500" boxSize={4} mr={1} />
                    <Text fontWeight="bold" color="gray.700">
                        No workplans updated.
                    </Text>
                </Flex>
            )}
        </Flex>
    );
};
export default BulkActionMessage;
